import TaskSidebar from './TaskSidebar.view';

export default TaskSidebar;
